"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VIDEO_STATES;
(function (VIDEO_STATES) {
    VIDEO_STATES["INIT"] = "init";
    VIDEO_STATES["VISIBLE"] = "visible";
    VIDEO_STATES["DRAFT"] = "draft";
    VIDEO_STATES["OVER_QUOTA"] = "over-quota";
})(VIDEO_STATES = exports.VIDEO_STATES || (exports.VIDEO_STATES = {}));
//# sourceMappingURL=video-states.js.map